export default "__VITE_ASSET__B05o18$4__"